import React from "react";

const Achievement = ({ title, image, participants }) => {
	return (

		<h1>No Upcoming Events for Now!</h1>
	);
};

export default Achievement;
